import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authService from "./authService";
import { RouteNames } from "../../constants";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import {AuthUserI} from "../../interfaces";
import customHistory from "../../components/RouteHistory";


interface AuthState {
  isLoading: boolean;
  isSuccessful: boolean;
  error: string;
  user: AuthUserI;
}

const initialState: AuthState = {
  isLoading: false,
  isSuccessful: false,
  error: "",
  user: {
    firstName: "",
    surname: "",
    userType: "",
    userPermissions: "",
    pin: "",
    contibutionBalance: 0,
    vcBalance: 0,
    image: "",
    fund: "",
    loginExpiry: "",
    isRecaptured: false,
    employerId: 0,
    employerBranchId: 0,
    isPhoneNumberVerified: false,
    isEmailVerified: false,
    isMPP:false,
    isRegistrationIncomplete: false
  },
};

export const loginUser = createAsyncThunk(
  "auth/login",
  // if you type your function argument here
  async (loginData: any, { rejectWithValue }) => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      const response = await authService.login(loginData);
      console.log('response',response);
      if (response.status === 200 ) {
        localStorage.setItem(
          "user",
          JSON.stringify(response.data.responseObject, null, 2)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(response.data.token, null)
        );
        // navigate
      }
      return response.data.responseObject;
    } catch (error) {
      console.log('error',error);
      console.log('response',error?.response);
      const data = error?.response?.data;
      const statusCode = data?.statusCode || data?.StatusCode;
      // Login OTP challenge — password OK, no session yet
      if (error?.response?.status === 400 && statusCode === "2FA") {
        return rejectWithValue(data);
      }
      if (error?.response?.status === 400  && statusCode==='03') {
        localStorage.setItem(
          "user",
          JSON.stringify(data?.responseObject || data?.ResponseObject, null, 2)
        );
        localStorage.setItem(
          "token",
          JSON.stringify(data?.token || data?.Token, null)
        );
        return rejectWithValue(data);
      }else
      if (error instanceof AxiosError) {
        if (error.response) {
          // Server returned a response with an error status (e.g., 404, 500)
          toast.error(error.response?.data?.message || error.response?.data?.statusMessage || error.response?.data?.Message || error.response?.data?.StatusMessage || "Login failed. Please try again.");
          return rejectWithValue(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received, possibly a network timeout
          toast.error('Network error: Request timed out or server is down.');
          // You can return a specific error message or code here if needed
          return rejectWithValue({ message: 'Network error' });
        } else {
          // Something else happened while setting up the request
          toast.error('An error occurred while making the request.');
          // You can return a specific error message or code here if needed
          return rejectWithValue({ message: 'Request error' });
        }
      } else {
        // Handle non-Axios errors (e.g., client-side errors) here
        console.error(error);
        toast.error('An unexpected error occurred.');
        // You can return a specific error message or code here if needed
        return rejectWithValue({ message: 'Unexpected error' });
      }
    }
  }
);
export const populateUserData = createAsyncThunk(
  "auth/populateUserData",
  (userData: any, { rejectWithValue }) => {
    return userData;
  }
);

export const forgotPassword = createAsyncThunk(
  "auth/forgotPassword",
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await authService.forgotPassword(data);
      if (response.status === 200) {
        toast.success("Password reset! check your mail for reset link");
      } else {
        toast.error(response?.data?.statusMessage);
      }
      return response.data;
    } catch (error) {
      const err = error as AxiosError<{ message: string }>;
      toast.error(err.response?.data.message);
      return rejectWithValue(err?.response?.data);
    }
  }
);
export const logoutUser = createAsyncThunk("auth/logout", async () => {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    customHistory.push(RouteNames.LOGIN)
    return;
  } catch (e) {
    toast.error("Error Logging out please try again");
    return;
  }
});

export const SignupUser = createAsyncThunk(
    "signup/user",
    async (data: any, { rejectWithValue }) => {
      try {
        const response = await authService.signup(data);
        if (response.status === 200) {
          toast.success(response?.data.message);
        } else {
          // @ts-ignore
          toast.error(response.response?.data?.errors?.title);
          return;
        }
        return response.data;
      } catch (error) {
        const err = error as AxiosError<{ message: string }>;
        // @ts-ignore
        toast.error(err.response?.data?.statusMessage);
        // @ts-ignore
        return rejectWithValue(err?.response?.data);
      }
    }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    noTract: () => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state, action) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          user: action.payload,
        };
      })
      .addCase(loginUser.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          // error: action.payload.message,
        };
      })
      .addCase(populateUserData.fulfilled, (state, action) => {
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        user: action.payload,
      };
    });
    builder
        .addCase(SignupUser.pending, (state, action) => {
          return {
            ...state,
            isLoading: true,
          };
        })
        .addCase(SignupUser.fulfilled, (state, action) => {
          return {
            ...state,
            isLoading: false,
            isSuccessful: true,
          };
        })
        .addCase(SignupUser.rejected, (state, action) => {
          return {
            ...state,
            isLoading: false,
            isSuccessful: false,
            //error: action.payload.message,
          };
        });
  },
});

export default authSlice.reducer;
